export const initMomentsSlider = () => {
  const slider = document.querySelector('[data-moments-slider]');
  if (!slider) {
    return;
  }
  const swiper = new Swiper(slider, {
    spaceBetween: 20,
    slidesPerView: 1.1,
    breakpoints: {
      // 391: {
      //   slidesPerView: 1.5,
      // },
      577: {
        slidesPerView: 1.4,
      },
      769: {
        slidesPerView: 2.1,
      },
      921: {
        slidesPerView: 2.3,
      },
      1161: {
        slidesPerView: 2.8,
      },
      1441: {
        slidesPerView: 3.2,
      },
      1601: {
        slidesPerView: 3.8,
      },
    },
  });
};
